var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',_vm._l((_vm.HIGHLIGHT_FIELDS),function({ name, key }){return _c('StatCard',{key:key,staticClass:"span-3",attrs:{"title":name,"is-loading":_vm.isLoading,"badge":_vm.highlights[`${key}Ctr`],"badge-color":_vm.highlights[`${key}CtrColor`]}},[_vm._v("\n    "+_vm._s(_vm._f("numberFormatter")(_vm.highlights[key],2))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }